import { Box, TextButton } from "@wix/design-system";
import React, { useContext, useMemo } from "react";
import { containsUrl, HTML_TYPE } from "./../../../ricos-content";
import { EditorContext, RicosContext } from "./../../../ricos-context";
import { HTMLData_Source } from "./../../../ricos-schema/legacy/wix/rich_content/v1";
import { FloatingLayout, FooterActions } from "./../../../ui-components";
import { EDIT_PANEL, EDIT_PANEL_CANCEL_BUTTON, EDIT_PANEL_UPDATE_BUTTON } from "../../dataHooks";
import { AdsenseSourceInput } from "./AdsenseSourceInput";
import { HtmlSourceInput } from "./HtmlSourceInput";
const InsertModal = ({ nodeId, closeModal }) => {
  const { getEditorCommands } = useContext(EditorContext);
  const { isMobile } = useContext(RicosContext);
  const inputRef = React.useRef(null);
  const componentData = getEditorCommands().getBlockComponentData(nodeId);
  const initialComponentData = useMemo(() => componentData, []);
  const isAdsense = componentData?.isAdsense ?? componentData.source === HTMLData_Source.ADSENSE;
  const updateComponentData = (data) => {
    getEditorCommands().setBlock(nodeId, HTML_TYPE, {
      ...data,
      id: nodeId
    });
  };
  const handleOnCancel = () => {
    updateComponentData(initialComponentData);
    closeModal();
  };
  const HtmlComponent = isAdsense ? AdsenseSourceInput : HtmlSourceInput;
  const Footer = isMobile ? FooterActions : FooterActionsDesktop;
  return /* @__PURE__ */ React.createElement(
    FloatingLayout,
    {
      onCloseButtonClick: handleOnCancel,
      dataHook: EDIT_PANEL,
      header: isMobile ? { title: "Edit HTML" } : void 0,
      content: {
        noPadding: true,
        children: /* @__PURE__ */ React.createElement(Box, { direction: "vertical", gap: "SP2", margin: "18px 18px 3px 18px" }, /* @__PURE__ */ React.createElement(
          HtmlComponent,
          {
            componentData,
            updateComponentData,
            inputRef
          }
        ))
      },
      footer: {
        showDivider: isMobile,
        children: /* @__PURE__ */ React.createElement(
          Footer,
          {
            onCancel: handleOnCancel,
            onSave: () => {
              if (componentData.url && !containsUrl(componentData.url)) {
                inputRef.current?.focus();
                return;
              }
              closeModal();
            }
          }
        )
      }
    }
  );
};
const FooterActionsDesktop = ({
  onCancel,
  onSave
}) => {
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(Box, { align: "space-between" }, /* @__PURE__ */ React.createElement(
    TextButton,
    {
      underline: "always",
      size: "small",
      dataHook: EDIT_PANEL_CANCEL_BUTTON,
      onClick: onCancel
    },
    t("HtmlEditPanel_Cancel")
  ), /* @__PURE__ */ React.createElement(
    TextButton,
    {
      underline: "always",
      size: "small",
      dataHook: EDIT_PANEL_UPDATE_BUTTON,
      onClick: onSave
    },
    t("HtmlEditPanel_Update")
  ));
};
export {
  InsertModal
};
//# sourceMappingURL=InsertModal.js.map
